module.exports = __webpack_public_path__ + "img/hotel.e0f8eff8.svg";